/* eslint-disable no-console */
import { belongsTo, createServer, hasMany, Model, Response } from "miragejs";

import randomWords from "random-words";
import { v4 as uuid } from "uuid";

import * as sortTypes from "constants/sortTypes";
import isValidId from "../functions/isValidId";

const dummyResourceTypes = ["zip", "file", "mp3", "pdf"];
const dummyResourceGroups = Array.from({ length: 8 }, () => randomWords(1)[0]);

const sites = [
  {
    siteId: 44,
    customisableItems: [
      {
        name: "html",
        items: [
          {
            id: uuid(),
            typeID: 4,
            customised: true,
            customisable: true,
            name: randomWords(1)[0],
            value:
              "<h2>" +
              randomWords(2).join(" ") +
              "</h2>" +
              "<p>" +
              randomWords(10).join(" ") +
              "</p>",
            extData: undefined,
          },
          {
            id: uuid(),
            typeID: 4,
            customised: false,
            customisable: true,
            name: randomWords(1)[0],
            value: "<p>default</p>",
            extData: undefined,
          },
        ],
      },
      {
        name: "text",
        items: [
          {
            id: uuid(),
            typeID: 1,
            customised: true,
            customisable: true,
            name: randomWords(1)[0],
            value: randomWords(10).join(" "),
            extData: undefined,
          },
          {
            id: uuid(),
            typeID: 2,
            customised: false,
            customisable: false,
            name: randomWords(1)[0],
            value: "default",
            extData: undefined,
          },
        ],
      },
      {
        name: "image",
        items: [
          {
            id: uuid(),
            typeID: 3,
            customised: true,
            customisable: true,
            name: "red logo",
            value:
              "https://rareearthdigital.com/wp-content/themes/red-twentytwenty/assets/img/RED-logo-landscape.svg",
            extData: undefined,
          },
          {
            id: uuid(),
            typeID: 3,
            customised: true,
            customisable: true,
            name: "Random image from red site",
            value: "https://rareearthdigital.com/wp-content/uploads/2020/07/homepage_banner.png",
            extData: undefined,
          },
        ],
      },
      {
        name: "email",
        items: [
          {
            id: uuid(),
            typeID: 5,
            customised: true,
            customisable: true,
            name: randomWords(1)[0],
            value:
              "<h2>" +
              randomWords(2).join(" ") +
              "</h2>" +
              "<p>" +
              randomWords(10).join(" ") +
              "</p>",
            extData: {
              subject: randomWords(3).join(" "),
              fromName: randomWords(1)[0],
              replyName: randomWords(1)[0],
              ccName: randomWords(1)[0],
              bccName: randomWords(1)[0],
              fromAddress: randomWords(1)[0] + "@" + randomWords(1)[0] + ".com",
              replyAddress: randomWords(1)[0] + "@" + randomWords(1)[0] + ".com",
              ccAddress: randomWords(1)[0] + "@" + randomWords(1)[0] + ".com",
              bccAddress: randomWords(1)[0] + "@" + randomWords(1)[0] + ".com",
              css: "",
            },
          },
        ],
      },
    ],
  },
];

const dummyUsers = [
  {
    token: "ec38b31d-c422-478e-95ec-202190db05c3",
    username: "service+admin@rareearthdigital.com",
    password: "banana",
    displayName: "Admin User",
    globalAdmin: false,
  },
  {
    token: "29a7e6ec-8f53-46fe-9f98-82f438319b13",
    username: "service+global@rareearthdigital.com",
    password: "oracle",
    displayName: "Global Admin",
    globalAdmin: true,
  },
  {
    token: "28ce5669-e2b6-4286-a5a2-339416ef36d0",
    username: "service+pwchange@rareearthdigital.com",
    password: "password",
    displayName: "PasswordChange User",
    globalAdmin: true,
    passwordChangeRequired: true,
  },
];

const dummyCourses = Array.from({ length: 30 }, (_c, c) => ({
  name: randomWords(2).join(" "),
  id: c,
  courseId: c,
  url: "/courses/" + randomWords(1)[0] + "/default.htm",
}));

const dummyPortals = Array.from({ length: 100 }, (_val, portalId) => {
  const licensed = !!(portalId % 2);
  const courses = [...dummyCourses].sort(() => 0.5 - Math.random()).slice(0, 10);
  const portal = {
    Created: new Date(),
    Expiry: new Date(),
    Product: randomWords(2).join(" "),
    Company: randomWords(3).join(" "),
    URL: randomWords(2).join("-"),
    Code: portalId,
    courses,
    licensed,
    hasUserLimit: false,
    userLimit: 0,
    portalExpires: true,
    expires: 4,
    instanceAdminAccessType: "Can delete non-accessed users",
    instanceCustomisable: true,
    instanceResources: false,
    accountManagerFirstName: randomWords(1)[0],
    accountManagerLastName: randomWords(1)[0],
    accountManagerEmail: randomWords(2).join("@") + ".com",
    logo:
      "https://rareearthdigital.com/wp-content/themes/red-twentytwenty/assets/img/RED-logo-landscape.svg",
    users: Array.from({ length: 30 }, (_val, userId) => ({
      id: userId,
      firstName: randomWords(1)[0],
      lastName: randomWords(1)[0],
      Email: `${randomWords(1)[0]}@${randomWords(1)[0]}.com`,
      Created: new Date(),
      "First Access": new Date(),
      "Last Access": new Date(),
      Accesses: Math.round(10 * Math.random()),
      courses: courses.map((course) => {
        const started = Math.random() < 0.5 ? new Date() : null;
        const completed = started && Math.random() < 0.5 ? new Date() : null;
        return {
          ...course,
          hasAccess: Math.random() > 0.5,
          expires: licensed && new Date(),
          started,
          completed,
        };
      }),
    })),
    resources: Array.from({ length: 5 }, (_g, g) => {
      const started = Math.random() < 0.5 ? new Date() : null;
      const completed = started && Math.random() < 0.5 ? new Date() : null;
      return {
        id: g,
        groupId: g,
        name: randomWords(3).join(" "),
        status: Math.floor(6 * Math.random()),
        started,
        completed,
        hidden: false,
        resources: Array.from({ length: 3 }, (_r, r) => ({
          id: r,
          resourceId: r,
          name: randomWords(1)[0],
          description: randomWords(10).join(" "),
          instructions: randomWords(10).join(" "),
          status: Math.floor(3 * Math.random()),
          hidden: false,
          type: dummyResourceTypes[Math.floor(dummyResourceTypes.length * Math.random())],
          group: dummyResourceGroups[Math.floor(dummyResourceGroups.length * Math.random())],
        })),
        dependencies: dummyCourses.sort(() => 0.5 - Math.random()).slice(0, 5),
      };
    }),
    customisableItems: [
      {
        name: "html",
        items: [
          {
            id: uuid(),
            typeID: 4,
            customised: true,
            customisable: true,
            name: randomWords(1)[0],
            value:
              "<h2>" +
              randomWords(2).join(" ") +
              "</h2>" +
              "<p>" +
              randomWords(10).join(" ") +
              "</p>",
            extData: undefined,
          },
          {
            id: uuid(),
            typeID: 4,
            customised: false,
            customisable: true,
            name: randomWords(1)[0],
            value: "<p>default</p>",
            extData: undefined,
          },
        ],
      },
      {
        name: "text",
        items: [
          {
            id: uuid(),
            typeID: 1,
            customised: true,
            customisable: true,
            name: randomWords(1)[0],
            value: randomWords(10).join(" "),
            extData: undefined,
          },
          {
            id: uuid(),
            typeID: 2,
            customised: false,
            customisable: false,
            name: randomWords(1)[0],
            value: "default",
            extData: undefined,
          },
        ],
      },
      {
        name: "image",
        items: [
          {
            id: uuid(),
            typeID: 3,
            customised: true,
            customisable: true,
            name: "red logo",
            value:
              "https://rareearthdigital.com/wp-content/themes/red-twentytwenty/assets/img/RED-logo-landscape.svg",
            extData: undefined,
          },
          {
            id: uuid(),
            typeID: 3,
            customised: true,
            customisable: true,
            name: "Random image from red site",
            value: "https://rareearthdigital.com/wp-content/uploads/2020/07/homepage_banner.png",
            extData: undefined,
          },
        ],
      },
      {
        name: "email",
        items: [
          {
            id: uuid(),
            typeID: 5,
            customised: true,
            customisable: true,
            name: randomWords(1)[0],
            value:
              "<h2>" +
              randomWords(2).join(" ") +
              "</h2>" +
              "<p>" +
              randomWords(10).join(" ") +
              "</p>",
            extData: {
              subject: randomWords(3).join(" "),
              fromName: randomWords(1)[0],
              replyName: randomWords(1)[0],
              ccName: randomWords(1)[0],
              bccName: randomWords(1)[0],
              fromAddress: randomWords(1)[0] + "@" + randomWords(1)[0] + ".com",
              replyAddress: randomWords(1)[0] + "@" + randomWords(1)[0] + ".com",
              ccAddress: randomWords(1)[0] + "@" + randomWords(1)[0] + ".com",
              bccAddress: randomWords(1)[0] + "@" + randomWords(1)[0] + ".com",
              css: "",
            },
          },
        ],
      },
    ],
  };
  if (licensed) {
    const coursesWithCurrentLicences = courses
      .sort(() => 0.5 - Math.random())
      .slice(0, Math.round(courses.length / 2));
    const coursesWithoutLicences = courses.filter(
      (course) => !coursesWithCurrentLicences.includes(course)
    );
    let licenceId = 0;
    portal.licences = [
      // Add some history
      ...Array.from({ length: 8 }, () =>
        ((course) => {
          const total = Math.round(10 * Math.random());
          return {
            ...course,
            licence: {
              current: false,
              id: licenceId++,
              allocated: total - Math.round((total / 2) * Math.random()),
              total,
              expiry: new Date(),
            },
          };
        })({
          ...coursesWithCurrentLicences[
            Math.floor(coursesWithCurrentLicences.length * Math.random())
          ],
        })
      ),
      // add some current licences
      ...coursesWithCurrentLicences.map(({ id, name }) => {
        const total = Math.round(10 * Math.random());
        return {
          id,
          name,
          licence: {
            current: true,
            id: licenceId++,
            allocated: total - Math.round((total / 2) * Math.random()),
            total,
            expiry: new Date(),
          },
        };
      }),
      // add the rest of the courses
      ...coursesWithoutLicences,
    ];
  }
  return portal;
});

const nDummyAdmins = 5;

const dummyAdmins = Array.from({ length: nDummyAdmins }, (_a, a) => ({
  id: a,
  adminId: a,
  Email: `${randomWords(1)[0]}@${randomWords(1)[0]}.com`,
  BCC: `${randomWords(1)[0]}@${randomWords(1)[0]}.com`,
  firstName: randomWords(1)[0],
  lastName: randomWords(1)[0],
  adminType: Math.random() < 0.33 ? 2 : Math.random < 0.66 ? 1 : 0,
  portals: dummyPortals.filter(() => Math.random() < 0.2),
  reportingInterval: Math.random() < 0.5 ? 1 : 2,
}));

const dummyResourceSets = Array.from({ length: 5 }, (_rs, rs) => ({
  id: rs,
  name: randomWords(3).join(" "),
  groups: Array.from({ length: 5 }, (_g, g) => ({
    id: g,
    groupId: g,
    name: randomWords(3).join(" "),
    resources: Array.from({ length: 3 }, (_r, r) => ({
      id: r,
      resourceId: r,
      name: randomWords(1)[0],
      description: randomWords(10).join(" "),
      instructions: randomWords(10).join(" "),
      status: Math.floor(3 * Math.random()),
      type: dummyResourceTypes[Math.floor(dummyResourceTypes.length * Math.random())],
      group: dummyResourceGroups[Math.floor(dummyResourceGroups.length * Math.random())],
      dependencies: dummyCourses.sort(() => 0.5 - Math.random()).slice(0, 5),
    })),
    dependencies: dummyCourses.sort(() => 0.5 - Math.random()).slice(0, 5),
  })),
}));

export function makeServer({ environment = "test" } = {}) {
  return createServer({
    routes() {
      this.namespace = "/";
      this.timing = 1200;
      this.passthrough(`${process.env.REACT_APP_API_URL}/**`);

      this.passthrough(`${process.env.REACT_APP_API_URL}/**`);

      this.post("/tokeninfo", (schema, request) => {
        const { token } = JSON.parse(request.requestBody);
        const user = dummyUsers.find((user) => user.token === token);
        if (user) {
          return {
            token,
            user,
          };
        }
        return new Response(401);
      });

      this.post("/login", (schema, request) => {
        const credentials = JSON.parse(request.requestBody);
        const user = dummyUsers.find(
          (user) => user.username === credentials.username && user.password === credentials.password
        );
        if (user) {
          return {
            token: user.token,
          };
        }
        return new Response(401);
      });

      this.post("/resetpassword", () => ({}));

      this.post("/changepassword", (schema, request) => {
        const token = request.requestHeaders.Authorization.split(" ")[1];
        const { password } = JSON.parse(request.requestBody);

        const user = dummyUsers.find(({ token: userToken }) => token === userToken);

        if (!user) {
          return new Response(404);
        }
        user.password = password;
        user.passwordChangeRequired = false;

        return {
          token: user.token,
        };
      });

      this.post("/revoketoken", () => ({}));

      this.post("/portals", (schema, request) => {
        const { page, entries, search, sort } = JSON.parse(request.requestBody);

        const filteredRows = dummyPortals
          .filter((portal) =>
            search ? [portal.Product, portal.Company].join(" ").indexOf(search) > -1 : portal
          )
          .sort((a, b) =>
            sort.col && sort.dir
              ? sort.dir === sortTypes.ASC
                ? a[sort.col] < b[sort.col]
                  ? -1
                  : a[sort.col] > b[sort.col]
                  ? 1
                  : 0
                : sort.dir === sortTypes.DESC
                ? a[sort.col] < b[sort.col]
                  ? 1
                  : a[sort.col] > b[sort.col]
                  ? -1
                  : 0
                : 0
              : 0
          )
          .map((portal) => ({
            ...portal,
            Product: portal["Product"] + (portal.licensed ? " (licensed)" : ""),
          }));

        return {
          filtered: filteredRows.length,
          total: dummyPortals.length,
          rows:
            entries === "all"
              ? filteredRows
              : filteredRows.slice((page - 1) * entries, page * entries),
        };
      });

      this.post("/portal/details", (schema, request) => {
        console.log("[portalId]", request.requestBody);

        // const portal = dummyPortals.find((p) => p["Code"] === portalId);
        //
        // if (!portal) {
        //   return new Response(404);
        // }

        const portal = dummyPortals[0];

        return {
          logo: portal["Logo"],
          product: portal["Product"],
          company: portal["Company"],
          courses: portal.courses,
          licensed: portal.licensed,
          easyURL: portal.URL,
        };
      });

      this.post("/portal/summary", (schema, request) => {
        const { portalId } = JSON.parse(request.requestBody);

        console.log("[portalId]", request.requestBody);

        const portal = dummyPortals.find((p) => p["Code"] === parseInt(portalId));

        if (!portal) {
          return new Response(404);
        }

        const date = new Date();

        return {
          alerts: portal.courses.map(
            ({ name }) =>
              `<p>${name} will expire in 15 days</p><p><strong>Please contact someone.</strong>&nbsp;</p>`
          ),
          expiry: portal.Expiry,
          overview: {
            URL: portal.URL,
            created: portal.Created,
            users: {
              accessed: Math.ceil(50 * Math.random()),
              notAccessed: Math.ceil(50 * Math.random()),
            },
          },
          summary: portal.courses.map((course) => ({
            ...course,
            completed: Math.ceil(10 * Math.random()),
            passed: Math.ceil(10 * Math.random()),
            inProgress: Math.ceil(10 * Math.random()),
            notStarted: Math.ceil(10 * Math.random()),
          })),
          contacts: [
            "ILX Account Manager",
            "Portal Administrator",
            "Portal Owner",
            "Administrator",
          ].map((title) => ({
            title,
            ...(({ id, Email, firstName, lastName }) => ({
              id,
              email: Email,
              name: `${firstName} ${lastName}`,
            }))(dummyAdmins[Math.floor(Math.random() * dummyAdmins.length)]),
          })),
          courseActivity: Array.from({ length: 8 }, () => ({
            activity: randomWords(6).join(" "),
            date: date,
          })),
          activeLicenceSummary: portal.courses.map((course) => ({
            ...course,
            allocated: Math.ceil(10 * Math.random()),
            unused: Math.ceil(10 * Math.random()),
            created: date,
          })),
        };
      });

      this.post("/portal/reportevents", (schema, request) => {
        const { portalId, page, entries, search, sort } = JSON.parse(request.requestBody);

        console.log("[/portal/reportevents]", request.requestBody);

        const portal = dummyPortals.find((p) => p["Code"] === parseInt(portalId));

        if (!portal) {
          return new Response(404);
        }

        let data = portal.users.map((user) => {
          let newUser = {
            ...user,
            date: new Date(),
            event: randomWords(3).join(" "),
            ip: "127.0.0.0",
            eventData: randomWords(10).join(" "),
            userAgent: "Mozilla or somat",
          };

          return newUser;
        });

        const filteredData = data
          .filter(({ Firstname, Lastname, Email }) => {
            return search ? [Firstname, Lastname, Email].join(" ").indexOf(search) > -1 : true;
          })
          .sort((a, b) =>
            sort.col && sort.dir
              ? sort.dir === sortTypes.ASC
                ? a[sort.col] < b[sort.col]
                  ? -1
                  : a[sort.col] > b[sort.col]
                  ? 1
                  : 0
                : sort.dir === sortTypes.DESC
                ? a[sort.col] < b[sort.col]
                  ? 1
                  : a[sort.col] > b[sort.col]
                  ? -1
                  : 0
                : 0
              : 0
          );

        return {
          filtered: filteredData.length,
          total: data.length,
          rows:
            entries === "all"
              ? filteredData
              : filteredData.slice(page * entries, (page + 1) * entries),
        };
      });

      this.post("/portal/reportcompletions", (schema, request) => {
        const { portalId } = JSON.parse(request.requestBody);

        console.log("[portalId]", request.requestBody);
        const portal = dummyPortals.find((p) => p["Code"] === portalId);

        if (!portal) {
          return new Response(404);
        }

        // return portal.users.map((user) => {
        //   let a = {};
        //   a.lastName = user.lastName;
        //   a.firstName = user.firstName;
        //   a.email = user.Email;
        //   a.numberAvailable = Math.ceil(10 * Math.random());
        //   a.numberCompleted = Math.ceil(10 * Math.random());
        //   a.numberStarted = Math.ceil(10 * Math.random());
        //   a.hasCompletedAll = a.numberCompleted === a.numberAvailable ? 1 : 0;
        //   a.hasStarted = a.numberStarted > 1 ? 1 : 0;
        //   a.courses = [];
        //   dummyCourses.map((course) => {
        //     a.courses.push({ name: course.name, val: Math.random() > 0.5 ? 1 : 0 });
        //   });
        //   return a;
        // });

        return {
          filtered: 1,
          total: 1,
          mainHeaders: [
            { title: "First Name", key: "firstName", sort: "ASC" },
            { title: "Last Name", key: "lastName", sort: "" },
            { title: "Email", key: "email", sort: "" },
            { title: "Number Available", key: "numberAvailable", sort: "" },
            { title: "Number Completed", key: "numberCompleted", sort: "" },
            { title: "Number Started", key: "numberStarted", sort: "" },
            { title: "Has Completed All", key: "hasCompletedAll", sort: "" },
            { title: "Has Started", key: "hasStarted", sort: "" },
          ],
          extHeaders: [
            {
              title: "Courses",
              headings: ["Course 1", "Course 2", "Course 3"],
            },
          ],
          data: [
            {
              firstName: "Bob",
              lastName: "Dylan",
              email: "bobdylan@music.com",
              numberAvailable: 4,
              numberCompleted: 2,
              numberStarted: 1,
              hasCompletedAll: 0,
              hasStarted: 1,
              mainData: [1, 0, 1],
            },
          ],
        };
      });

      this.post("/portal/reportuserprogress", (schema, request) => {
        const { portalId } = JSON.parse(request.requestBody);

        console.log("[portalId/courseId]", request.requestBody);
        const portal = dummyPortals.find((p) => p["Code"] === portalId);

        if (!portal) {
          return new Response(404);
        }

        //   let r = [];
        //
        //   portal.users.map((user) => {
        //     let a = {};
        //     a.lastName = user.lastName;
        //     a.firstName = user.firstName;
        //     a.email = user.Email;
        //     a.numberAvailable = Math.ceil(10 * Math.random());
        //     a.numberCompleted = Math.ceil(10 * Math.random());
        //     a.numberStarted = Math.ceil(10 * Math.random());
        //     a.hasCompletedAll = a.numberCompleted === a.numberAvailable ? 1 : 0;
        //     a.hasStarted = a.numberStarted > 1 ? 1 : 0;
        //     a.courses = [];
        //     dummyCourses.map((course) => {
        //       a.courses.push({ name: course.name, val: Math.random() > 0.5 ? 1 : 0 });
        //     });
        //     r.push(a);
        //   });
        //
        //   return r;
        // });
      });

      this.post("/portal/reportuserprogress", (schema, request) => {
        const { portalId } = JSON.parse(request.requestBody);
        console.log("[portalId/courseId]", request.requestBody);
        const portal = dummyPortals.find((p) => p["Code"] === portalId);

        if (!portal) {
          return new Response(404);
        }

        return {
          filtered: 2,
          total: 2,
          mainHeaders: [
            { title: "First Name", key: "firstName", sort: "ASC" },
            { title: "Last Name", key: "lastName", sort: "ASC" },
            { title: "Email", key: "email", sort: "ASC" },
          ],
          extHeaders: [
            {
              title: "Section1",
              headings: [
                "Section1 Heading1",
                "Section2 Heading2",
                "Section3 Heading3",
                "Section4 Heading4",
              ],
            },
            {
              title: "Section2",
              headings: [
                "Section2 Heading1",
                "Section2 Heading2",
                "Section2 Heading3",
                "Section2 Heading4",
              ],
            },
          ],
          data: [
            {
              firstName: "Bob",
              lastName: "Dylan",
              email: "bobdylan@music.com",
              mainData: [
                "R1S1H1",
                "R1S1H2",
                "R1S1H3",
                "R1S1H4",
                "R1S2H1",
                "R1S2H2",
                "R1S2H3",
                "R1S2H4",
              ],
            },
            {
              firstName: "Jesus",
              lastName: "Christ",
              email: "imnotreal@nigeria.com",
              mainData: [
                "R2S1H1",
                "R2S1H2",
                "R2S1H3",
                "R2S1H4",
                "R2S2H1",
                "R2S2H2",
                "R2S2H3",
                "R2S2H4",
              ],
            },
          ],
        };
      });

      this.post("/portal/reportsummary", (schema, request) => {
        const { portalId, courseId } = JSON.parse(request.requestBody);

        console.log("[portalId/courseId]", request.requestBody);
        const portal = dummyPortals.find((p) => p["Code"] === portalId);

        if (!portal) {
          return new Response(404);
        }

        const date = new Date();

        let returnObj = {
          courseActivity: Array.from({ length: 8 }, () => ({
            activity: randomWords(6).join(" "),
            date: date,
          })),
          completions: Array.from({ length: 5 }, (d, _d) => ({
            date: new Date(),
            completions: Math.round(200 * Math.random()),
          })),
        };

        if (courseId) {
          const course = portal.courses.find((p) => p["id"] === courseId);
          returnObj.courseName = course.name;
          returnObj.summary = [
            {
              ...course,
              completed: Math.ceil(10 * Math.random()),
              passed: Math.ceil(10 * Math.random()),
              inProgress: Math.ceil(10 * Math.random()),
              notStarted: Math.ceil(10 * Math.random()),
            },
          ];

          returnObj.activeLicenceSummary = [
            {
              ...course,
              allocated: Math.ceil(10 * Math.random()),
              unused: Math.ceil(10 * Math.random()),
              created: date,
            },
          ];

          returnObj.examAttempts = [
            {
              name: course.name,
              attempts: Math.ceil(10 * Math.random()),
            },
          ];
        } else {
          returnObj.summary = portal.courses.map((course) => ({
            ...course,
            completed: Math.ceil(10 * Math.random()),
            passed: Math.ceil(10 * Math.random()),
            inProgress: Math.ceil(10 * Math.random()),
            notStarted: Math.ceil(10 * Math.random()),
          }));

          returnObj.activeLicenceSummary = portal.courses.map((course) => ({
            ...course,
            allocated: Math.ceil(10 * Math.random()),
            unused: Math.ceil(10 * Math.random()),
            created: date,
          }));

          returnObj.examAttempts = portal.courses.map(({ name }) => ({
            name,
            attempts: Math.ceil(10 * Math.random()),
          }));
        }
        return returnObj;
      });

      this.post("/portal/users", (schema, request) => {
        const { portalId, page, entries, search, sort } = JSON.parse(request.requestBody);

        console.log("[/portal/users]", request.requestBody);

        const portal = dummyPortals.find((p) => p["Code"] === parseInt(portalId));

        if (!portal) {
          return new Response(404);
        }

        const filteredUsers = portal.users
          .filter(({ firstName, lastName, Email }) => {
            return search ? [firstName, lastName, Email].join(" ").indexOf(search) > -1 : true;
          })
          .sort((a, b) =>
            sort.col && sort.dir
              ? sort.dir === sortTypes.ASC
                ? a[sort.col] < b[sort.col]
                  ? -1
                  : a[sort.col] > b[sort.col]
                  ? 1
                  : 0
                : sort.dir === sortTypes.DESC
                ? a[sort.col] < b[sort.col]
                  ? 1
                  : a[sort.col] > b[sort.col]
                  ? -1
                  : 0
                : 0
              : 0
          );

        return {
          filtered: filteredUsers.length,
          total: portal.users.length,
          rows: (entries === "all"
            ? filteredUsers
            : filteredUsers.slice((page - 1) * entries, page * entries)
          ).map((user) => ({
            ...user,
            userId: user.id,
          })),
        };
      });

      this.post("/portal/user/details", (schema, request) => {
        const { portal: portalId, user: userId } = JSON.parse(request.requestBody);

        if (!isValidId(portalId) || !isValidId(userId)) {
          return new Response(400);
        }

        const portal = dummyPortals.find((p) => p["Code"] === parseInt(portalId));
        if (!portal) {
          return new Response(404);
        }

        const user = portal.users.find((u) => u.id === parseInt(userId));
        if (!user) {
          return new Response(404);
        }

        return {
          ...user,
          expires: new Date(2022, 1, 21),
        };
      });

      this.post("/portal/user/update", (schema, request) => {
        const { user: userId, portal: portalId, data } = JSON.parse(request.requestBody);

        if (!isValidId(portalId)) {
          return new Response(400);
        }

        const portal = dummyPortals.find(({ Code }) => Code === parseInt(portalId));

        if (!portal) {
          console.log("no portal");
          return new Response(404);
        }

        if (!userId) {
          const newId = uuid();
          portal.users.push({
            ...data,
            id: newId,
            Created: new Date(),
            Accesses: Math.round(10 * Math.random()),
          });
          return {
            portalId,
            userId: newId,
          };
        }

        const userIndex = portal.users.findIndex(({ id }) => id === parseInt(userId));

        if (userIndex < 0) {
          console.log("no user");
          return new Response(404);
        }

        const user = portal.users[userIndex];

        portal.users[userIndex] = {
          ...user,
          ...data,
          courses: user.courses,
        };

        user.courses.forEach((course) => {
          const courseData = data.courses.find(({ id }) => id === course.id);
          if (courseData) {
            course.hasAccess = !!courseData.hasAccess;
          }
        });

        console.log("[user updated]", user);
        return user;
      });

      this.post("/portal/user/progress", (schema, request) => {
        const { portalId, userId, courseId } = JSON.parse(request.requestBody);

        const portal = dummyPortals.find(({ Code }) => Code === portalId);

        if (!portal) return new Response(404);

        const user = portal.users.find(({ id }) => id === userId);

        if (!user) return new Response(404);

        const progress = user.courses.map((course) => {
          return {
            ...course,
            courseId: course.id,
            status: Math.floor(7 * Math.random()),
            score: Math.floor(101 * Math.random()),
            time: 60 * Math.floor(24 * 60 * Math.random()),
          };
        });

        if (isValidId(courseId)) {
          const course = progress.find(({ courseId: id }) => id === courseId);

          if (!course) return new Response(404);

          return {
            ...course,
            modules: Array.from({ length: 20 }, (_m, m) => ({
              moduleId: m,
              name: randomWords(2).join(" "),
              status: Math.floor(6 * Math.random()),
              time: 60 * Math.floor(24 * 60 * Math.random()),
            })),
          };
        }

        return progress;
      });

      this.post("/portal/user/progress/update", (schema, request) => {
        return new Response(200);
      });

      this.post("/administrators", (schema, request) => {
        const { page, entries, search, sort } = JSON.parse(request.requestBody);

        const filteredRows = dummyAdmins
          .filter((admin) =>
            search ? [admin.firstName, admin.lastName].join(" ").indexOf(search) > -1 : admin
          )
          .sort((a, b) =>
            sort.col && sort.dir
              ? sort.dir === sortTypes.ASC
                ? a[sort.col] < b[sort.col]
                  ? -1
                  : a[sort.col] > b[sort.col]
                  ? 1
                  : 0
                : sort.dir === sortTypes.DESC
                ? a[sort.col] < b[sort.col]
                  ? 1
                  : a[sort.col] > b[sort.col]
                  ? -1
                  : 0
                : 0
              : 0
          );

        return {
          filtered: filteredRows.length,
          total: dummyPortals.length,
          rows:
            entries === "all"
              ? filteredRows
              : filteredRows.slice((page - 1) * entries, page * entries),
        };
      });

      this.post("/administrator/details", (schema, request) => {
        const { adminId } = JSON.parse(request.requestBody);

        const admin = dummyAdmins.find((p) => p["id"] === adminId);
        if (!admin) {
          return new Response(404);
        }

        return admin;
      });

      this.post("/administrator/portals", (schema, request) => {
        const { adminId, page, entries, search, sort } = JSON.parse(request.requestBody);

        const admin = dummyAdmins.find((p) => p["id"] === adminId);
        if (!admin) {
          return new Response(404);
        }

        const filteredPortals = admin.portals
          .filter(({ Product, Company }) => {
            return search ? [Product, Company].join(" ").indexOf(search) > -1 : true;
          })
          .sort((a, b) =>
            sort.col && sort.dir
              ? sort.dir === sortTypes.ASC
                ? a[sort.col] < b[sort.col]
                  ? -1
                  : a[sort.col] > b[sort.col]
                  ? 1
                  : 0
                : sort.dir === sortTypes.DESC
                ? a[sort.col] < b[sort.col]
                  ? 1
                  : a[sort.col] > b[sort.col]
                  ? -1
                  : 0
                : 0
              : 0
          );

        return {
          filtered: filteredPortals.length,
          total: admin.portals.length,
          rows:
            entries === "all"
              ? filteredPortals
              : filteredPortals.slice((page - 1) * entries, page * entries),
        };
      });

      this.post("/administrator/available_portals", (schema, request) => {
        const { adminId, page, entries, search, sort } = JSON.parse(request.requestBody);

        const admin = dummyAdmins.find((p) => p["id"] === adminId);
        if (!admin) {
          return new Response(404);
        }

        const availablePortals = dummyPortals.filter((p) => !admin.portals.includes(p));

        const filteredPortals = availablePortals
          .filter(({ Product, Company }) => {
            return search ? [Product, Company].join(" ").indexOf(search) > -1 : true;
          })
          .sort((a, b) =>
            sort.col && sort.dir
              ? sort.dir === sortTypes.ASC
                ? a[sort.col] < b[sort.col]
                  ? -1
                  : a[sort.col] > b[sort.col]
                  ? 1
                  : 0
                : sort.dir === sortTypes.DESC
                ? a[sort.col] < b[sort.col]
                  ? 1
                  : a[sort.col] > b[sort.col]
                  ? -1
                  : 0
                : 0
              : 0
          );

        return {
          filtered: filteredPortals.length,
          total: availablePortals.length,
          rows:
            entries === "all"
              ? filteredPortals
              : filteredPortals.slice((page - 1) * entries, page * entries),
        };
      });

      this.post("/administrator/update", (schema, request) => {
        const { admin: adminId, data } = JSON.parse(request.requestBody);

        if (!adminId) {
          const newId = uuid();
          dummyAdmins.push({
            id: newId,
            portals: dummyPortals.filter(() => Math.random() < 0.2),
            ...data,
          });
          return newId;
        }

        const admin = dummyAdmins.find((p) => p["id"] === adminId);
        if (!admin) {
          return new Response(404);
        }

        const adminIndex = dummyAdmins.findIndex((a) => a === admin);

        const newAdmin = {
          ...admin,
          ...data,
        };

        dummyAdmins[adminIndex] = newAdmin;

        return { ...newAdmin };
      });

      this.post("/administrator/manage_portals", (schema, request) => {
        const { admin: adminId, data } = JSON.parse(request.requestBody);
        console.log("[/administrator/manage_portals]", adminId, data);
        const { portalId, add } = data;

        const admin = dummyAdmins.find((p) => p["id"] === adminId);
        if (!admin) {
          return new Response(404);
        }

        if (add) {
          if (!admin.portals.some(({ Code }) => Code === parseInt(portalId))) {
            admin.portals.push(dummyPortals.find(({ Code }) => Code === parseInt(portalId)));
          }
        } else {
          console.log(`Removing... ${admin.portals.length}`);
          admin.portals = admin.portals.filter(({ Code }) => Code !== portalId);
          console.log(`Removed... ${admin.portals.length}`);
        }

        return {
          success: true,
        };
      });

      this.post("/portal_options", () => ({
        sites: Array.from({ length: 3 }, () => randomWords(1)[0]),
        reporting: ["None", "Bronze", "Silver", "Gold"],
        availableCourses: dummyCourses,
        chosenCourses: [],
      }));

      this.post("/portal/licences", (schema, request) => {
        const { portalId } = JSON.parse(request.requestBody);

        const portal = dummyPortals.find((p) => p["Code"] === portalId);

        if (!portal) {
          return new Response(404);
        }

        if (!portal.licensed) {
          return new Response(400);
        }

        return portal.licences;
      });

      this.post("/portal/licensing/update", (schema, request) => {
        const { portal: portalId, licence: licenceid, course: courseid, ...data } = JSON.parse(
          request.requestBody
        );

        const portal = dummyPortals.find((p) => p["Code"] === parseInt(portalId));

        if (!portal) {
          return new Response(404);
        }

        if (!portal.licensed) {
          return new Response(400);
        }

        // if a licence id is specified, we're updating it
        if (licenceid || licenceid === 0) {
          console.log("looking for licence...");

          // yes, there's a licence within a licence
          const licenceIndex = portal.licences.findIndex(
            (licence) =>
              licence.licence &&
              licence.licence.id === parseInt(licenceid) &&
              licence.licence.current
          );

          if (licenceIndex > -1) {
            const licence = portal.licences[licenceIndex];
            console.log("[licence was]", licence);

            // can't reissue fewer licences than are allocated
            if (licence.licence.allocated > parseInt(data.total)) {
              return new Response(400);
            }

            licence.licence.total = parseInt(data.total);
            licence.licence.expiry = new Date(data.expiry);

            console.log("[licence now]", licence);

            return portal.licences;
          }

          return new Response(404);
        }

        // otherwise, if a course id is specified, we're creating or replacing a licence
        if (courseid || (typeof courseid === "number" && courseid === 0)) {
          const currentLicence = portal.licences.find(
            (licence) => licence.id === courseid && !!licence.licence && licence.licence.current
          );

          if (currentLicence) {
            if (currentLicence.licence.allocated > parseInt(data.total)) {
              return new Response(400);
            }

            // clone the current licence, then discontinue it
            console.log("cloning and discontinuing...");
            portal.licences.push({
              ...currentLicence,
              licence: {
                ...currentLicence.licence,
                ...data,
                total: parseInt(data.total),
                current: true, // just to be explicit
                id: portal.licences.length,
              },
            });
            currentLicence.licence.current = false;
            return portal.licences;
          }

          const course = portal.courses.find(({ id }) => id === courseid);

          if (course) {
            console.log("inserting course int");
            portal.licences.push({
              ...course,
              licence: {
                ...data,
                allocated: 0,
                total: parseInt(data.total),
                current: true,
                id: portal.licences.length,
              },
            });
            return portal.licences;
          }

          return new Response(404);
        }

        return portal.licences;
      });

      this.post("/resource_sets", () =>
        dummyResourceSets.map(({ name, id }) => ({ name, setId: id }))
      );

      this.post("/resource_set", (schema, request) => {
        const { setId, portalId } = JSON.parse(request.requestBody);

        if (isValidId(setId) && isValidId(portalId)) return new Response(400);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === parseInt(portalId));

          if (!portal) return new Response(404);

          console.log(portal);

          return portal.resources.map((group) => ({
            ...group,
            groupId: group.id,
          }));
        }

        if (isValidId(setId)) {
          const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

          if (!set) return new Response(404);

          return {
            ...set,
            setId: set.id,
            groups: set.groups.map((group) => ({
              ...group,
              groupId: group.id,
            })),
          };
        }
      });

      this.post("/resource_set/update", (schema, request) => {
        const { setId, ...data } = JSON.parse(request.requestBody);

        const setIndex = dummyResourceSets.findIndex(({ id }) => id === parseInt(setId));

        if (setIndex < 0) {
          const newSet = {
            name: data.name,
            id: dummyResourceSets.length,
            groups: [],
          };
          dummyResourceSets.push(newSet);
          return newSet;
        }

        const set = dummyResourceSets[setIndex];

        dummyResourceSets[setIndex] = {
          ...set,
          name: data.name,
        };

        return dummyResourceSets[setIndex];
      });

      this.post("/resource_set/move_group", (schema, request) => {
        const { setId, portalId, data } = JSON.parse(request.requestBody);

        if (isValidId(setId) && isValidId(portalId)) return new Response(400);

        const { groupId, newIndex } = data;

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          const groupIndex = portal.resources.findIndex(({ id }) => id === groupId);

          if (groupIndex < 0) return new Response(404);

          portal.resources.splice(newIndex, 0, portal.resources.splice(groupIndex, 1)[0]);

          return portal.resources.map((resource) => ({
            ...resource,
            groupId: resource.id,
          }));
        }

        if (isValidId(setId)) {
          const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

          if (!set) return new Response(404);

          const groupIndex = set.groups.findIndex(({ id }) => id === parseInt(groupId));

          if (groupIndex < 0) return new Response(404);

          set.groups.splice(newIndex, 0, set.groups.splice(groupIndex, 1)[0]);

          return set;
        }

        return new Response(400);
      });

      this.post("/resource_groups", (schema, request) => {
        const { setId, portalId } = JSON.parse(request.requestBody);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          return portal.resources.map(({ id, name }) => ({ name, groupId: id }));
        }

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        return set.groups.map(({ id, name }) => ({ groupId: id, name }));
      });

      this.post("/resource_group", (schema, request) => {
        const { setId, portalId, groupId } = JSON.parse(request.requestBody);

        if ((setId || setId === 0) && (portalId || portalId === 0)) return new Response(400);

        if (portalId || portalId === 0) {
          const portal = dummyPortals.find(({ Code }) => Code === parseInt(portalId));

          if (!portal) return new Response(404);

          const group = portal.resources.find(({ id }) => id === parseInt(groupId));

          if (!group) return new Response(404);

          return {
            ...group,
            groupId: group.id,
            resources: group.resources.map((resource) => ({
              ...resource,
              resourceId: resource.id,
            })),
          };
        }

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        const group = set.groups.find(({ id }) => id === parseInt(groupId));

        if (!group) return new Response(404);

        return {
          ...group,
          groupId: group.id,
          resources: group.resources.map((resource) => ({
            ...resource,
            resourceId: resource.id,
          })),
        };
      });

      this.post("/resource_group/create", (schema, request) => {
        const { setId, portalId, data } = JSON.parse(request.requestBody);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          const newResourceGroup = {
            id: portal.resources.length,
            name: data.name,
            status: 1,
            hidden: false,
            resources: [],
            dependencies: [],
          };

          portal.resources.push(newResourceGroup);

          return {
            portalId: portal.Code,
            groupId: newResourceGroup.id,
          };
        }

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        const newResourceGroup = {
          id: set.groups.length,
          name: data.name,
          status: 0,
          hidden: false,
          resources: [],
          dependencies: [],
        };

        set.groups.push(newResourceGroup);

        return {
          setId: set.id,
          groupId: newResourceGroup.id,
        };
      });

      this.post("/resource_group/update", (schema, request) => {
        const { setId, portalId, groupId, data } = JSON.parse(request.requestBody);

        if (isValidId(setId) && isValidId(portalId)) return new Response(400);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          const groupIndex = portal.resources.findIndex(({ id }) => id === groupId);

          if (!groupIndex < 0) return new Response(404);

          const group = portal.resources[groupIndex];

          portal.resources[groupIndex] = {
            ...group,
            ...data,
          };

          return portal.resources[groupIndex];
        }

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        const groupIndex = set.groups.findIndex(({ id }) => id === parseInt(groupId));

        if (groupIndex < 0) return new Response(404);

        const group = set.groups[groupIndex];

        set.groups[groupIndex] = {
          ...group,
          ...data,
        };

        return set.groups[groupIndex];
      });

      this.post("/resource_group/move_resource", (schema, request) => {
        const { setId, portalId, groupId, data } = JSON.parse(request.requestBody);

        if (isValidId(setId) && isValidId(portalId)) return new Response(404);

        let group;

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          group = portal.resources.find(({ id }) => id === groupId);
        } else {
          const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

          if (!set) return new Response(404);

          group = set.groups.find(({ id }) => id === parseInt(groupId));
        }

        if (!group) return new Response(404);

        const { resourceId, newIndex } = data;

        const resourceIndex = group.resources.findIndex(({ id }) => id === parseInt(resourceId));

        if (resourceIndex < 0) return new Response(404);

        group.resources.splice(newIndex, 0, group.resources.splice(resourceIndex, 1)[0]);

        return group.resources.map((resource) => ({
          ...resource,
          resourceId: resource.id,
        }));
      });

      this.post("/resource_group/delete", (schema, request) => {
        const { setId, portalId, groupId } = JSON.parse(request.requestBody);

        if (isValidId(setId) && isValidId(portalId)) return new Response(400);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          const group = portal.resources.find(({ id }) => id === groupId);

          if (!group) return new Response(404);

          group.hidden = true;

          return {
            portalId: portal.Code,
            groupId: group.id,
          };
        }

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        const targetGroup = set.groups.find(({ id }) => id === parseInt(groupId));

        if (!targetGroup) return new Response(404);

        set.groups = set.groups.filter((group) => group !== targetGroup);

        return {
          setId: set.id,
          groupId: targetGroup.id,
        };
      });

      this.post("/resource_group/restore", (schema, request) => {
        const { portalId, groupId } = JSON.parse(request.requestBody);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          const group = portal.resources.find(({ id }) => id === groupId);

          if (!group) return new Response(404);

          group.hidden = false;

          return {
            portalId: portal.Code,
            groupId: group.id,
          };
        }

        return new Response(400);
      });

      this.post("/dependencies", (schema, request) => {
        const { setId, portalId, groupId, resourceId } = JSON.parse(request.requestBody);

        let group;
        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          group = portal.resources.find(({ id }) => id === groupId);
        } else {
          const set = dummyResourceSets.find(({ id }) => id === setId);

          if (!set) return new Response(404);

          group = set.groups.find(({ id }) => id === groupId);
        }

        if (!group) return new Response(404);

        if (isValidId(resourceId)) {
          const resource = group.resources.find(({ id }) => id === resourceId);

          if (!resource) return new Response(404);

          return resource.dependencies;
        }

        return group.dependencies;
      });

      this.post("/dependencies/search", (schema, request) => {
        const { setId, groupId, search } = JSON.parse(request.requestBody);

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        const targetGroup = set.groups.find(({ id }) => id === parseInt(groupId));

        if (!targetGroup) return new Response(404);

        const searchString = search.toLocaleLowerCase();

        return dummyCourses
          .filter(({ name }) => !search || name.toLowerCase().indexOf(searchString) > -1)
          .map(({ id, name, url }) => ({ id, name, url }));
      });

      this.post("/dependencies/add", (schema, request) => {
        const { setId, groupId, resourceId, courseId } = JSON.parse(request.requestBody);

        const course = dummyCourses.find(({ id }) => id === courseId);

        if (!course) return new Response(404);

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        const group = set.groups.find(({ id }) => id === parseInt(groupId));

        if (!group) return new Response(404);

        if (isValidId(resourceId)) {
          const resource = group.resources.find(({ id }) => id === resourceId);

          if (!resource) return new Response(404);

          resource.dependencies.push(course);

          return new Response(200);
        }

        if (group.dependencies.some(({ id }) => id === courseId)) return new Response(200);

        group.dependencies.push(course);

        return new Response(200);
      });

      this.post("/dependencies/remove", (schema, request) => {
        const { setId, groupId, resourceId, courseId } = JSON.parse(request.requestBody);

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        const group = set.groups.find(({ id }) => id === parseInt(groupId));

        if (!group) return new Response(404);

        if (isValidId(resourceId)) {
          const resource = group.resources.find(({ id }) => id === resourceId);

          if (!resource) return new Response(404);

          resource.dependencies = resource.dependencies.filter(({ id }) => id !== courseId);

          return new Response(200);
        }

        group.dependencies = group.dependencies.filter(({ id }) => id !== courseId);

        return new Response(200);
      });

      this.post("/resource/update", (schema, request) => {
        const { setId, portalId, groupId, resourceId, data } = JSON.parse(request.requestBody);

        if (isValidId(setId) && isValidId(portalId)) return new Response(400);

        let group;
        let response = {};
        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === parseInt(portalId));

          if (!portal) return new Response(404);

          group = portal.resources.find(({ id }) => id === parseInt(groupId));

          if (!group) return new Response(404);

          response = {
            ...response,
            portalId: portal.id,
            groupId: group.id,
          };
        } else {
          const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

          if (!set) return new Response(404);

          group = set.groups.find(({ id }) => id === parseInt(groupId));

          if (!group) return new Response(404);

          response = {
            ...response,
            setId: set.id,
            groupId: group.id,
          };
        }

        if (isValidId(resourceId)) {
          const resourceIndex = group.resources.findIndex(({ id }) => id === parseInt(resourceId));
          const resource = group.resources[resourceIndex];

          if (resourceIndex < 0) return new Response(404);

          const updatedResource = {
            ...resource,
            ...data,
          };

          group.resources[resourceIndex] = updatedResource;

          return updatedResource;
        }

        let newId = 0;
        // eslint-disable-next-line no-loop-func
        while (group.resources.some(({ id }) => id === newId)) newId++;

        const newResource = {
          id: newId,
          name: "",
          description: "",
          instructions: "",
          deprecated: false,
          type: dummyResourceTypes[Math.floor(dummyResourceTypes.length * Math.random())],
          group: dummyResourceGroups[Math.floor(dummyResourceGroups.length * Math.random())],
          dependencies: [],
          ...data,
        };

        group.resources.push(newResource);

        return {
          ...response,
          resourceId: newId,
        };
      });

      this.post("/resource/delete", (schema, request) => {
        const { setId, portalId, groupId, resourceId } = JSON.parse(request.requestBody);

        if (isValidId(setId) && isValidId(portalId)) return new Response(400);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === parseInt(portalId));

          if (!portal) return new Response(404);

          const group = portal.resources.find(({ id }) => id === parseInt(groupId));

          if (!group) return new Response(404);

          const resource = group.resources.find(({ id }) => id === resourceId);

          if (!resource) return new Response(404);

          resource.hidden = true;

          return {
            portalId: portal.Code,
            groupId: group.id,
            resourceId: resource.id,
          };
        } else {
          const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

          if (!set) return new Response(404);

          const group = set.groups.find(({ id }) => id === parseInt(groupId));

          if (!group) return new Response(404);

          const targetResource = group.resources.find(({ id }) => id === resourceId);

          group.resources = group.resources.filter((resource) => resource !== targetResource);

          return {
            setId: set.id,
            groupId: group.id,
            resourceId: targetResource.id,
          };
        }
      });

      this.post("/resource/restore", (schema, request) => {
        const { portalId, groupId, resourceId } = JSON.parse(request.requestBody);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === portalId);

          if (!portal) return new Response(404);

          const group = portal.resources.find(({ id }) => id === groupId);

          if (!group) return new Response(404);

          const resource = group.resources.find(({ id }) => id === resourceId);

          if (!resource) return new Response(404);

          resource.hidden = false;

          return {
            portalId: portal.Code,
            groupId: group.id,
            resourceId: resource.id,
          };
        }

        return new Response(400);
      });

      this.post("/resource", (schema, request) => {
        const { setId, groupId, portalId, resourceId } = JSON.parse(request.requestBody);

        if (isValidId(portalId) && isValidId(setId)) return new Response(400);

        if (isValidId(portalId)) {
          const portal = dummyPortals.find(({ Code }) => Code === parseInt(portalId));

          if (!portal) return new Response(404);

          const group = portal.resources.find(({ id }) => id === parseInt(groupId));

          if (!group) return new Response(404);

          const resource = group.resources.find(({ id }) => id === parseInt(resourceId));

          if (!resource) return new Response(404);

          return resource;
        }

        const set = dummyResourceSets.find(({ id }) => id === parseInt(setId));

        if (!set) return new Response(404);

        const group = set.groups.find(({ id }) => id === parseInt(groupId));

        if (!group) return new Response(404);

        const resource = group.resources.find(({ id }) => id === parseInt(resourceId));

        if (!resource) return new Response(404);

        return resource;
      });

      this.post("/reset_resources", (schema, request) => {
        const { portalId, setId } = JSON.parse(request.requestBody);

        if (!isValidId(portalId)) return new Response(400);

        const portal = dummyPortals.find(({ Code }) => Code === portalId);

        if (!portal) return new Response(404);

        if (!isValidId(setId)) {
          portal.resources = [];
        } else {
          const set = dummyResourceSets.find(({ id }) => id === setId);

          if (!set) return new Response(404);

          portal.resources = [...set.groups];
        }

        return { portalId: portal.Code };
      });
      this.post("/portal/updatecustomitem", (schema, request) => {
        const { portalId, data } = JSON.parse(request.requestBody);

        console.log("[portalId]", request.requestBody);

        const portal = dummyPortals.find((p) => p["Code"] === parseInt(portalId));

        if (!portal) {
          return new Response(404);
        }

        let cItems = [...portal.customisableItems];

        let tabNumber;
        let itemNumber;
        cItems.forEach((tab, tabN) => {
          tab.items.forEach((tabItem, itemN) => {
            if (data.id === tabItem.id) {
              tabNumber = tabN;
              itemNumber = itemN;

              if (data.setToDefault) {
                cItems[tabN].items[itemN].value = "default";
                cItems[tabN].items[itemN].extData = {};
                cItems[tabN].items[itemN].customised = false;
              } else {
                console.log(cItems[tabN]);
                cItems[tabN].items[itemN] = data;
                cItems[tabN].items[itemN].customised = true;
              }

              return;
            }
          });
        });

        portal.customisableItems = cItems;

        return cItems[tabNumber].items[itemNumber];
      });

      this.post("/portal/customitems", (schema, request) => {
        const { portalId } = JSON.parse(request.requestBody);

        console.log("[portalId]", request.requestBody);

        const portal = dummyPortals.find((p) => p["Code"] === portalId);

        if (!portal) {
          return new Response(404);
        }

        return portal.customisableItems;
      });

      this.post("/customitems", (schema, request) => {
        const { siteId } = JSON.parse(request.requestBody);

        console.log("[siteId]", request.requestBody);

        const site = sites.find((p) => p["siteId"] === siteId);

        if (!site) {
          return new Response(404);
        }

        return site.customisableItems;
      });

      this.post("/createcustomitem", (schema, request) => {
        const { siteId } = JSON.parse(request.requestBody);

        console.log("[siteId]", request.requestBody);

        const site = sites.find((p) => p["siteId"] === siteId);

        if (!site) {
          return new Response(404);
        }
      });

      this.post("/updatecustomitem", (schema, request) => {
        const { siteId, data } = JSON.parse(request.requestBody);

        console.log("[siteId]", request.requestBody);

        const site = sites.find((p) => p["siteId"] === siteId);

        if (!site) {
          return new Response(404);
        }

        let cItems = [...site.customisableItems];

        let tabNumber;
        let itemNumber;
        cItems.forEach((tab, tabN) => {
          tab.items.forEach((tabItem, itemN) => {
            if (data.id === tabItem.id) {
              tabNumber = tabN;
              itemNumber = itemN;

              console.log(cItems[tabN]);
              cItems[tabN].items[itemN] = data;
              cItems[tabN].items[itemN].customised = true;

              return;
            }
          });
        });

        site.customisableItems = cItems;

        return cItems[tabNumber].items[itemNumber];
      });
    },

    environment,

    models: {
      portal: Model.extend({
        users: hasMany(),
      }),
      user: Model.extend({
        portal: belongsTo(),
      }),
    },
  });
}
